import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SavedCartsComponent } from './saved-carts.component'
import { CmsConfig, provideDefaultConfig } from '@spartacus/core'
import { SharedModule } from '../../shared/shared.module'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../guards/user-permissions.guard'

@NgModule({
  declarations: [SavedCartsComponent],
  imports: [CommonModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        SavedCartsComponent: {
          component: SavedCartsComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class SavedCartsModule {}
